import { ShowMoreText } from "./components/show-more-button";
import { ShowPricesInfo, ToggleEventBoxes, ClickAddToCartButton } from "./components/engagement-boxes";
import { RecommendationFormSubmit } from "./components/recommendation-form";
import {
	EcondaDownloadTracking,
	EcondaTrackingCart,
	GoogleAnalytictsTrackingProduct,
	DataLayerDownloadTracking,
	ElearningTrackingCart
} from "./components/econda-tracking";
import { TrackingCart } from "../factfinder/components/tracking";

document.addEventListener("DOMContentLoaded", () => {
	EcondaTrackingCart();
	ElearningTrackingCart();
	GoogleAnalytictsTrackingProduct();
	EcondaDownloadTracking();
	ShowMoreText();
	ShowPricesInfo();
	ToggleEventBoxes();
	ClickAddToCartButton();
	RecommendationFormSubmit();
	TrackingCart();
	DataLayerDownloadTracking();
});
